"use client";

import { useScrollLock } from "@repo/lib/hooks/common";
import { IconCross, IconMenuLinkArrow } from "@repo/assets/images";
import cx from "classnames";
import { useTranslations } from "next-intl";
const OffCanvasMenu = ({
  open,
  handleClose,
  title,
  children,
  position,
  index,
  totalMenus
}) => {
  useScrollLock({
    lock: open
  });
  const t = useTranslations("Common");
  const isClient = typeof window !== "undefined";
  const isDesktop = isClient && window.innerWidth >= 1024;
  const zIndex = isDesktop ? index === 0 ? 70 : 69 - index // Desktop behavior
  : 70 + index; // Mobile behavior

  const translateX = isDesktop && open ? `${index * (document.dir === "rtl" ? -100 : 100)}%` : "0%";
  return <div className="fixed" style={{
    zIndex
  }} data-sentry-component="OffCanvasMenu" data-sentry-source-file="OffCanvasMenu.jsx">
      {open && index === totalMenus - 1 && <div className="fixed inset-0 bg-transparent" onClick={handleClose} style={{
      zIndex: -1
    }} />}
      <div className={cx("fixed bottom-0 top-0 h-screen w-[90%] overflow-y-auto transition-all duration-300 lg:w-[250px] xl:w-[320px] 2xl:w-[390px]", "ltr:shadow-[5px_0px_10px_0px_rgba(0,0,0,0.08)] rtl:shadow-[-5px_0px_10px_0px_rgba(0,0,0,0.08)]", {
      "translate-x-full rtl:-translate-x-full": position === "right" && !open,
      "-translate-x-full rtl:translate-x-full": position === "left" && !open,
      "ltr:left-0 rtl:right-0": position === "left",
      "ltr:right-0 rtl:left-0": position === "right",
      "bg-menu-hamburger-spill-bg": index % 2 === 0,
      "bg-menu-hamburger-spill-level2-bg": index % 2 !== 0
    })} style={{
      transform: open ? `translateX(${translateX})` : "",
      zIndex
    }}>
        <div className={cx("flex items-center px-4 py-2", {
        "lg:hidden": index > 0 // Hide header on desktop for nested menus
      })}>
          {index > 0 ? <button onClick={() => handleClose(index)} className="group flex items-center gap-2 lg:hidden">
              <IconMenuLinkArrow className="text-icon-color rotate-180 transition-transform duration-200 group-hover:ltr:-translate-x-1 rtl:rotate-0 group-hover:rtl:translate-x-1" />
              <span className="font-heading text-menu-hamburger-spill-text rtl:font-arabic py-[6px] text-xl font-medium md:text-4xl">
                {title}
              </span>
            </button> : <span className="font-heading text-menu-hamburger-spill-text rtl:font-arabic py-[6px] text-xl font-medium md:text-4xl">
              {t("Shop_By")}
            </span>}
          {index === 0 && <button type="button" className="ms-auto border-0 p-0" onClick={handleClose} name="close menu" aria-label="close menu">
              <IconCross className="text-icon-color hover:text-supportiveGray cursor-pointer fill-current font-bold" />
            </button>}
        </div>
        {children}
      </div>
    </div>;
};
export default OffCanvasMenu;